@if (chart(); as c) {
  <div class="sz-accuracy-stack__wrap">
    <svg class="sz-accuracy-stack" [attr.viewBox]="viewBox" xmlns="http://www.w3.org/2000/svg">
      <g class="sz-accuracy-stack__y-labels">
        @for (label of c.yLabels; track label.y) {
          <text [attr.x]="0" [attr.y]="label.y + 4">{{ label.text }}</text>
        }
      </g>
      <g class="sz-accuracy-stack__grid">
        @for (label of c.yLabels; track label.y) {
          <line [attr.x1]="padL" [attr.y1]="label.y" [attr.x2]="viewW" [attr.y2]="label.y" />
        }
      </g>
      <g class="sz-accuracy-stack__bars">
        @for (bar of c.bars; track bar.x; let i = $index) {
          <g [class.is-latest]="bar.isLatest">
            @for (seg of bar.segments; track seg.y) {
              <rect
                [class]="'sz-accuracy-stack__seg sz-accuracy-stack__seg--' + seg.kind"
                [attr.x]="bar.x"
                [attr.y]="seg.y"
                [attr.width]="bar.width"
                [attr.height]="seg.height" />
            }
          </g>
        }
      </g>
      <g class="sz-accuracy-stack__x-labels">
        @for (bar of c.bars; track bar.x) {
          <text [attr.x]="bar.x + bar.width / 2" [attr.y]="viewH - 8" text-anchor="middle">{{ bar.label }}</text>
        }
      </g>
    </svg>

    <ul class="sz-accuracy-stack__legend" aria-label="Zones legend">
      @for (item of legend; track item.kind) {
        <li class="sz-accuracy-stack__legend-item">
          <span [class]="'sz-accuracy-stack__legend-swatch sz-accuracy-stack__legend-swatch--' + item.kind"></span>
          <span class="sz-accuracy-stack__legend-label">{{ item.label }}</span>
        </li>
      }
    </ul>
  </div>
}
